














































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import CHeader from "@/components/CHeader.vue";
import CFooter from "@/components/CFooter.vue";
import CLoginForm from "@/components/forms/CLoginForm.vue";
import AuthModule from "@/store/auth";
import RestaurantModule from "@/store/restaurant";
import { NewMenu } from "@/api/api";
import { EditStatus } from "@/types";
import { RestaurantsApi, MenusApi, UGCsApi } from "@/services/api-service";
import TooltipModule from "@/store/tooltip";
import CTooltip from "@/components/CTooltip.vue";
import FormModal from "@/components/forms/FormModal.vue";

@Component({
  components: {
    CHeader,
    CFooter,
    CLoginForm,
    CTooltip,
    FormModal,
  },
})
export default class REditMenuForm extends Vue {
  private get me() {
    return AuthModule.me;
  }

  private get menu() {
    return RestaurantModule.menu;
  }

  private get editMenuStatus() {
    return RestaurantModule.editMenuStatus;
  }

  private get editStatus() {
    return EditStatus;
  }

  private get isTooltipShow() {
    return TooltipModule.isShow;
  }

  private form: NewMenu | { name: string; price: undefined; ugcUuid: undefined; hidden: boolean } = {
    name: "",
    price: undefined,
    ugcUuid: undefined,
    hidden: false,
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private file: any = null;

  private fileUrl: string | ArrayBuffer | null = null;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private onFileChange(e: any) {
    const files = e.target.files || e.dataTransfer.files;
    // eslint-disable-next-line prefer-destructuring
    this.file = files[0];
    this.createImage(files[0]);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private createImage(file: any) {
    const reader = new FileReader();
    reader.onload = e => {
      if (e.target && e.target.result) {
        this.fileUrl = e.target.result;
      }
    };
    return reader.readAsDataURL(file);
  }

  private confirm() {
    RestaurantModule.commitEditMenuStatus(EditStatus.Confirm);
    window.scrollTo(0, 0);
  }

  private backEdit() {
    RestaurantModule.commitEditMenuStatus(EditStatus.Edit);
    window.scrollTo(0, 0);
  }

  private goMenuList() {
    RestaurantModule.commitEditMenuStatus(null);
    this.$router.push({ name: "RMenus" });
  }

  private async submit() {
    if (!this.me?.uuid || this.form.price === null) {
      return;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const menuBody: any = { ...this.form };
    if (this.file) {
      const ugc = await this.uploadUGC(this.file);
      if (ugc.uuid) {
        menuBody.ugcUuid = ugc.uuid;
      }
    }

    try {
      if (this.menu) {
        // eslint-disable-next-line prettier/prettier
        const menuRes = await MenusApi.instance.patchMenuByUuid(this.menu.uuid, menuBody);
        if (!menuRes.data.data?.menu) {
          return;
        }
        window.scrollTo(0, 0);
      } else {
        const menuRes = await RestaurantsApi.instance.createMenuWithRestaurantUuid(this.me.uuid, menuBody);
        if (!menuRes.data.data?.menu) {
          return;
        }
        window.scrollTo(0, 0);
      }
    } catch (err) {
      console.log(err);
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private async uploadUGC(file: any) {
    try {
      const res = await UGCsApi.instance.createUGC(file);
      if (res.data.data?.ugc) {
        return res.data.data.ugc;
      }
      throw Error("Upload failed");
    } catch (err) {
      TooltipModule.commitIsShow(true);
      setTimeout(() => {
        TooltipModule.commitIsShow(false);
      }, 5000);
      throw err;
    }
  }

  @Watch("menu")
  private setMenu() {
    if (this.$route.name === "REditMenu") {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      this.form = this.menu as any;
    }
  }

  private created() {
    if (this.menu) {
      this.setMenu();
    }
  }

  // ここからモーダル//
  private testShow() {
    (this.$refs.test as FormModal).CtestShow();
    this.submit();
  }
  // ここまでモーダル//
}
